import React from 'react'

import { ICON_PLACEMENT, MODE, SIZE } from './constants'
import * as S from './styles'

import type { ButtonProps } from './types'
import type { FC } from 'react'

export const Button: FC<ButtonProps> = ({
  bold = false,
  isFullWidth = false,
  mode = MODE.primary,
  size = SIZE.big,
  icon = null,
  iconPlacement = ICON_PLACEMENT.beforeText,
  children,
  isDanger = false,
  border,
  ...restProps
}) => (
  <S.Button
    $bold={bold}
    $border={border}
    $isFullWidth={isFullWidth}
    $styleMode={mode}
    $styleSize={size}
    $isDanger={isDanger}
    type="button"
    {...restProps}
  >
    {iconPlacement === ICON_PLACEMENT.beforeText && icon}
    {children}
    {iconPlacement === ICON_PLACEMENT.afterText && icon}
  </S.Button>
)
